import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { loginDevicesBackend } from './login-devices.backend';
import { loginDevicesReducer } from './login-devices.reducer';

@NgModule({
  imports: [
    BackendModule.forFeature('loginDevices', loginDevicesBackend),
    StoreModule.forFeature('loginDevices', loginDevicesReducer),
  ],
})
export class DatastoreLoginDevicesModule {}
